import { render, staticRenderFns } from "./CollListItem.vue?vue&type=template&id=6eb82a1f&scoped=true"
import script from "./CollListItem.vue?vue&type=script&lang=js"
export * from "./CollListItem.vue?vue&type=script&lang=js"
import style0 from "./CollListItem.vue?vue&type=style&index=0&id=6eb82a1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb82a1f",
  null
  
)

export default component.exports